import { Component, Input, OnInit } from '@angular/core';
import { ArticleType, ArticleTypeAttribute, ArticleTypeAttributeGroup } from '../../article-type.model';

@Component({
  selector: 'app-article-type-attribute-list',
  templateUrl: './article-type-attribute-list.component.html',
  styleUrls: ['./article-type-attribute-list.component.scss']
})
export class ArticleTypeAttributeListComponent implements OnInit {

  articleType: ArticleType;

  @Input('articleType') set setArticleType(value: ArticleType) {
    console.log('input articleType', value);
    this.articleType = value;
  }

  @Input() editAttributeFunction: (arg1: any, arg2: any) => any;

  @Input() removeAttributeFunction: (arg1: any, arg2: any) => any;

  @Input() editAttributeGroupFunction: (arg2: any) => any;

  @Input() removeAttributeGroupFunction: (arg2: any) => any;

  constructor(
  ) { }

  ngOnInit(): void {
  }

  getNonDeletedAttributes(group: ArticleTypeAttributeGroup): Array<ArticleTypeAttribute> {
    return group.attributes.filter(a => !a.deleted);
  }

  getNonDeletedAttributeGroups(): Array<ArticleTypeAttributeGroup> {
    return this.articleType.attributeGroups.filter(g => !g.deleted);
  }

  editAttribute(attribute: ArticleTypeAttribute, group: ArticleTypeAttributeGroup) {
    if (this.editAttributeFunction != null) {
      this.editAttributeFunction(attribute, group);
    }
  }

  removeAttribute(attribute: ArticleTypeAttribute, group: ArticleTypeAttributeGroup) {
    if (this.removeAttributeFunction != null) {
      this.removeAttributeFunction(attribute, group);
    }
  }

  editAttributeGroup(group: ArticleTypeAttributeGroup) {
    if (this.editAttributeGroupFunction != null) {
      this.editAttributeGroupFunction(group);
    }
  }

  removeAttributeGroup(group: ArticleTypeAttributeGroup) {
    if (this.removeAttributeGroupFunction != null) {
      this.removeAttributeGroupFunction(group);
    }
  }

}
